/* js/components/CardMeta.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

function create_if_block(ctx) {
	let li;
	let t0;
	let t1_value = /*card*/ ctx[0].media.director + "";
	let t1;

	return {
		c() {
			li = element("li");
			t0 = text("vidéo réalisée par: ");
			t1 = text(t1_value);
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t0);
			append(li, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*card*/ 1 && t1_value !== (t1_value = /*card*/ ctx[0].media.director + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

function create_fragment(ctx) {
	let br;
	let t0;
	let ul;
	let li0;
	let t1_value = /*card*/ ctx[0].media.artist + "";
	let t1;
	let t2;
	let t3;
	let li1;
	let t4_value = (/*card*/ ctx[0].media.year || "") + "";
	let t4;
	let if_block = /*card*/ ctx[0].media.director && create_if_block(ctx);

	return {
		c() {
			br = element("br");
			t0 = space();
			ul = element("ul");
			li0 = element("li");
			t1 = text(t1_value);
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			li1 = element("li");
			t4 = text(t4_value);
			attr(ul, "class", "svelte-y6cm1d");
		},
		m(target, anchor) {
			insert(target, br, anchor);
			insert(target, t0, anchor);
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, t1);
			append(ul, t2);
			if (if_block) if_block.m(ul, null);
			append(ul, t3);
			append(ul, li1);
			append(li1, t4);
		},
		p(ctx, [dirty]) {
			if (dirty & /*card*/ 1 && t1_value !== (t1_value = /*card*/ ctx[0].media.artist + "")) set_data(t1, t1_value);

			if (/*card*/ ctx[0].media.director) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(ul, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*card*/ 1 && t4_value !== (t4_value = (/*card*/ ctx[0].media.year || "") + "")) set_data(t4, t4_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(br);
			if (detaching) detach(t0);
			if (detaching) detach(ul);
			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { card } = $$props;

	$$self.$$set = $$props => {
		if ('card' in $$props) $$invalidate(0, card = $$props.card);
	};

	return [card];
}

class CardMeta extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { card: 0 });
	}
}

export default CardMeta;